import { render, staticRenderFns } from "./FlightplanTable.vue?vue&type=template&id=485d0538&scoped=true"
import script from "./FlightplanTable.vue?vue&type=script&lang=js"
export * from "./FlightplanTable.vue?vue&type=script&lang=js"
import style0 from "./FlightplanTable.vue?vue&type=style&index=0&id=485d0538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d0538",
  null
  
)

export default component.exports